var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect8, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveIntensiveMinutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 149,
    viewBox: "0 0 282 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.927 120.847C124.306 119.23 135.463 105.452 133.847 90.0731C132.23 74.6938 118.452 63.5369 103.073 65.1533C87.6939 66.7697 76.5369 80.5474 78.1534 95.9267C79.7698 111.306 93.5475 122.463 108.927 120.847Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78 81.6535C107.458 82.2242 106.267 83.2131 105.264 84.3548C103.961 83.4555 102.675 82.727 101.263 82.4436C96.062 81.4357 92.2939 86.6681 92.7876 91.3661C93.7213 100.25 105.854 108.043 107.733 107.845C109.612 107.648 119.869 97.5879 118.926 88.6189C118.432 83.9208 113.488 79.6042 108.78 81.6535Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.1275,
    y: 67.1901,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-6 74.1275 67.1901)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.326 120.94C166.548 121.865 178.017 111.895 178.941 98.6727C179.866 85.4501 169.897 73.9816 156.674 73.057C143.451 72.1324 131.983 82.1018 131.058 95.3244C130.134 108.547 140.103 120.015 153.326 120.94Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.036 87.8341C157.835 88.1191 156.682 88.7765 155.666 89.591C154.699 88.6379 153.722 87.8316 152.573 87.3822C148.332 85.7573 144.373 89.6132 144.09 93.6524C143.556 101.29 152.638 109.674 154.253 109.787C155.869 109.9 166.024 102.935 166.563 95.2238C166.845 91.1846 163.314 86.8049 159.036 87.8341Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.805,
    y: 70.3155,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 131.805 70.3155)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.56 63.8933C189.965 65.2411 203.546 53.8453 204.894 38.4402C206.242 23.0351 194.846 9.45415 179.441 8.10638C164.036 6.7586 150.455 18.1543 149.107 33.5595C147.759 48.9646 159.155 62.5455 174.56 63.8933Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.895 25.3915C180.488 25.6995 179.13 26.4429 177.928 27.3723C176.82 26.2407 175.697 25.2803 174.365 24.7327C169.452 22.7509 164.754 27.1682 164.343 31.8741C163.564 40.7726 173.987 50.7374 175.869 50.9021C177.752 51.0667 189.739 43.1489 190.525 34.1648C190.936 29.4588 186.906 24.278 181.895 25.3915Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150.638,
    y: 4.58267,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(5 150.638 4.58267)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.41 42.591C126.414 41.6283 134.554 31.9277 133.591 20.924C132.628 9.92033 122.928 1.78052 111.924 2.74321C100.92 3.70591 92.7804 13.4066 93.7431 24.4102C94.7058 35.4139 104.406 43.5537 115.41 42.591Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.795 14.5959C114.843 14.987 113.98 15.6784 113.25 16.4813C112.33 15.8228 111.421 15.2865 110.416 15.0664C106.714 14.2818 103.958 17.9717 104.252 21.3331C104.808 27.6892 113.376 33.4059 114.72 33.2883C116.065 33.1706 123.515 26.1141 122.954 19.6969C122.659 16.3355 119.182 13.191 115.795 14.5959Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.9166,
    y: 3.57729,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(-5 90.9166 3.57729)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.924 100.591C195.928 101.554 205.628 93.4138 206.591 82.4101C207.554 71.4065 199.414 61.7058 188.41 60.7431C177.407 59.7804 167.706 67.9202 166.743 78.9239C165.781 89.9276 173.92 99.6282 184.924 100.591Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.163 73.0893C189.159 73.3094 188.188 73.8403 187.33 74.5042C186.538 73.696 185.736 73.0099 184.785 72.6188C181.275 71.2032 177.92 74.3584 177.626 77.7198C177.07 84.0759 184.515 91.1935 185.859 91.3112C187.204 91.4288 195.766 85.7732 196.328 79.356C196.622 75.9946 193.743 72.294 190.163 73.0893Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 167.577,
    y: 57.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 167.577 57.9166)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7002 79.6199C99.0795 78.0035 110.236 64.2258 108.62 48.8465C107.004 33.4673 93.2259 22.3103 77.8466 23.9267C62.4674 25.5431 51.3104 39.3209 52.9268 54.7001C54.5432 70.0794 68.3209 81.2364 83.7002 79.6199Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5537 40.425C82.2319 40.9957 81.0404 41.9846 80.0377 43.1263C78.7341 42.227 77.4484 41.4985 76.0368 41.215C70.8355 40.2072 67.0673 45.4396 67.5611 50.1376C68.4948 59.0212 80.6274 66.8141 82.5066 66.6166C84.3858 66.4191 94.642 56.3594 93.6993 47.3904C93.2055 42.6923 88.261 38.3757 83.5537 40.425Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9009,
    y: 25.9635,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-6 48.9009 25.9635)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11304_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.869 81.2457C147.051 82.6312 158.86 73.0681 160.246 59.8859C161.631 46.7037 152.068 34.8942 138.886 33.5087C125.704 32.1232 113.894 41.6863 112.509 54.8685C111.123 68.0507 120.687 79.8602 133.869 81.2457Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.731 48.3591C139.521 48.6021 138.346 49.2188 137.302 49.9974C136.369 49.011 135.421 48.1711 134.288 47.6819C130.107 45.91 126.015 49.6254 125.592 53.6523C124.792 61.2668 133.575 69.9626 135.186 70.1319C136.796 70.3012 147.188 63.6948 147.996 56.007C148.419 51.9801 145.043 47.4799 140.731 48.3591Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 114.128,
    y: 29.9009,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(6 114.128 29.9009)",
    stroke: "#FFE2E5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 91C58 89.8954 58.8954 89 60 89H80.2654C81.2607 89 82.1046 89.7319 82.2453 90.7172L85.7547 115.283C85.8954 116.268 86.7393 117 87.7346 117H188.265C189.261 117 190.105 116.268 190.245 115.283L193.755 90.7172C193.895 89.7319 194.739 89 195.735 89H216C217.105 89 218 89.8954 218 91V117V143C218 144.105 217.105 145 216 145H186H90H60C58.8954 145 58 144.105 58 143V117V91Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 55.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 57.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 6.5,
    r: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 30 149)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 32.5L245 28.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 74.5L240 76.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L35 26.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 85L36.5 82.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.2266,
    y: 68.0801,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 75.2266 68.0801)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.732,
    y: 71.3828,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(4 132.732 71.3828)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.547,
    y: 5.66602,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(5 151.547 5.66602)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 4.48633,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-5 92 4.48633)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.486,
    y: 59,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(5 168.486 59)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26.8535,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 50 26.8535)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11304_9692"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.018,
    y: 31,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(6 115.018 31)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveIntensiveMinutes);
export default __webpack_public_path__ + "static/media/collective-intensive-minutes.0451f2c584b7d0c4cc5c5d3dfc09addf.svg";
export { ForwardRef as ReactComponent };